import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'colmec-availability-warning',
    templateUrl: './colmec-availability-warning.component.html',
    styleUrls: ['./colmec-availability-warning.component.scss'],
    standalone: false
})
export class ColmecAvailabilityWarningComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
